import { useSelector, useDispatch } from 'react-redux';
import { fetchShopItems, fetchAllShopItems, fetchShopPacks } from '../store/shopSlice';

/**
 * Хук для работы с товарами магазина из Redux store
 */
export const useShopRedux = () => {
  const dispatch = useDispatch();
  const shop = useSelector((state) => state.shop);

  const loadItems = (type = null) => {
    dispatch(fetchShopItems(type));
  };

  const loadAllItems = () => {
    dispatch(fetchAllShopItems());
  };

  const loadPacks = () => {
    dispatch(fetchShopPacks());
  };

  return {
    items: shop.items,
    packs: shop.packs,
    isLoading: shop.isLoading,
    isLoadingPacks: shop.isLoadingPacks,
    error: shop.error,
    loadItems,
    loadAllItems,
    loadPacks,
  };
};

